/**
 * Precision Genetic Test Template
 * Main initialization file for all precision sections
 */

import initPrecisionHero from './precision-hero.js';
import initPrecisionSavingsComparison from './precision-savings-comparison.js';
import { initPrecisionTabs } from '../components/precision-tabs.js';
import { initPurchaseOptions } from '../components/precision-purchase-options.js';
import { initQuantityPriceUpdates, initPresetQuantity } from '../components/precision-preset-quantity.js';

function initPrecisionGeneticTest() {
  // Migrate sections first (tabs, modals, etc.)
  // Initialize all sections
  initPrecisionHero();
  initPrecisionSavingsComparison();
  initPrecisionTabs();
  // Initialize quantity-based price updates (always runs)
  initQuantityPriceUpdates();
  // Initialize purchase options (subscription/one-time)
  initPurchaseOptions();

  // Initialize preset quantity selector UI (only if presets enabled)
  initPresetQuantity();
}


document.addEventListener('DOMContentLoaded', () => {
  initPrecisionGeneticTest()
});

